import PhoneNumber from 'awesome-phonenumber';
import { Customer, CustomerContact } from 'store/customers/customer';

export const hasBillingDetails = (customer?: Customer | null): boolean => {
    const { billingName, billingEmail, billingCustomerCode } = customer?.customerDetails ?? {};
    return !!billingName && !!billingEmail && !!billingCustomerCode;
};

export const combinePhone = (contact: CustomerContact | undefined) => {
    if (!contact) return undefined;

    const contactClone = { ...contact };
    delete contactClone.phoneCountryCode;

    if (!contact.phoneCountryCode || !contact.phoneNumber) return contactClone;

    const combined = `${contact.phoneCountryCode}${contact.phoneNumber}`;
    const parsed = new PhoneNumber(combined);

    return {
        ...contactClone,
        // e164 is the international phone number format defined by the ITU (International Telecommunication Union).
        phoneNumber: parsed.isValid() ? parsed.getNumber('e164') : combined,
    };
};
